import { render, staticRenderFns } from "./Furioos.vue?vue&type=template&id=36fbf7a2&scoped=true&"
import script from "./Furioos.vue?vue&type=script&lang=js&"
export * from "./Furioos.vue?vue&type=script&lang=js&"
import style0 from "./Furioos.vue?vue&type=style&index=0&id=36fbf7a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbf7a2",
  null
  
)

export default component.exports